const authCodeKey = 'workwx_auth_code'

export const getWorkWxAuthCode = () => localStorage.getItem(authCodeKey)
export const setWorkWxAuthCode = (auth_code) => localStorage.setItem(authCodeKey, auth_code)
export const removeWorkWxAuthCode = () => localStorage.removeItem(authCodeKey)
